export const yupLocaleConfig = {
  mixed: {
    required: "messages:error.yup.required",
    oneOf: "messages:error.yup.required",
  },
  string: {
    email: "messages:error.yup.email",
  },
};
